import React from "react";
import "./Msone.css";
import msImg from "../../../Gallery/ServicesImages/material/img3.jpg"; // keep your same image path

function Msone() {
  return (
    <div className="ms_wrapper">

      <section className="ms_hero">
        <div className="ms_container">

          {/* LEFT IMAGE */}
          <div className="ms_image">
            <img src={msImg} alt="MS1 Injection Mould" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="ms_content">
            <h1>MS1 Injection Mould</h1>
            <div className="ms_line"></div>

            <p>
              High-performance MS1 injection mould featuring advanced conformal
              cooling channel design for improved thermal control and optimized
              production efficiency.
            </p>

            <p>
              Precision printed and post-machined to achieve superior surface
              finish and dimensional accuracy, ensuring long-lasting tooling
              performance and enhanced manufacturing output.
            </p>

          </div>

        </div>
      </section>

    </div>
  );
}

export default Msone;
